import React from 'react';

import DanImage from '@core/assets/images/video-testimonials/testimonial-dan-mugwagwa.png';
import EvelynImage from '@core/assets/images/video-testimonials/testimonial-evelyn-mendonca.png';
import SetareImage from '@core/assets/images/video-testimonials/testimonial-setare-shabani.png';

import classes from './VideoTestimonials.module.scss';

const VideoTestimonials = () => {
    const cardData = [
        {
            image: DanImage.src,
            time: '5:49',
            title: '“[Pharmuni] helped close that knowledge gap, and now I can lead the team with knowledge and confidence.”',
            name: 'Dan ID Mugwagwa',
            role: 'Production Manager',
            link: 'https://www.youtube.com/watch?v=y3dUM1roFTw&list=PLgScMB0-0YTwBrRD-wjl3MBjeIc88M0qg&index=3'
        },
        {
            image: EvelynImage.src,
            time: '3:22',
            title: '“I consider Pharmuni a holistic learning platform… you feel more confident about understanding your role.”',
            name: 'Evelyn Mendonca',
            role: 'Quality Assurance Specialist',
            link: 'https://www.youtube.com/watch?v=cfxfUjeSJdM&list=PLgScMB0-0YTwBrRD-wjl3MBjeIc88M0qg&index=2'
        },
        {
            image: SetareImage.src,
            time: '2:52',
            title: '“I took these courses, and they helped me have a claim to [current] position. And I just got the promotion.”',
            name: 'Setareh Shabani',
            role: 'Quality Management Specialist',
            link: 'https://www.youtube.com/watch?v=GLQGpN4K-Fo&list=PLgScMB0-0YTwBrRD-wjl3MBjeIc88M0qg&index=1'
        }
    ];
    return (
        <div className={classes.wrapper}>
            <div className={`container`}>
                <div className='row'>
                    <div className='col-12 d-flex flex-column align-items-center my-5'>
                        <h2>Real Stories. Real Career Wins.</h2>
                        <p>
                            How Pharmuni’s courses, career path, and coaching turned ambition into promotions,
                            confidence, and momentum—straight from our learners.
                        </p>
                        <div className={classes['card-wrapper']}>
                            {cardData.map((card, idx) => (
                                <a
                                    key={idx}
                                    href={card.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={classes.card}
                                >
                                    <div className={classes.imageWrapper}>
                                        <img src={card.image} alt={card.title} className={classes.image} />
                                        <div className={classes.time}>{card.time}</div>
                                    </div>
                                    <div className={classes.content}>
                                        <h3 className={classes.title}>{card.title}</h3>
                                        <div className={classes.meta}>
                                            <div className={classes.name}>{card.name}</div>
                                            <div className={classes.role}>{card.role}</div>
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoTestimonials;